import { render } from "./TypeChooserModal.vue?vue&type=template&id=7432f061"
import script from "./TypeChooserModal.vue?vue&type=script&lang=js"
export * from "./TypeChooserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__